// extracted by mini-css-extract-plugin
export var centerText = "_ee-8";
export var container = "_ee-0";
export var doughnutContainer = "_ee-7";
export var legend = "_ee-a";
export var legendItemColorDisplay = "_ee-b";
export var legendItemLabel = "_ee-d";
export var legendItemValue = "_ee-c";
export var lg = "_ee-5";
export var maxWidth = "_ee-9";
export var md = "_ee-4";
export var responsive = "_ee-6";
export var sm = "_ee-3";
export var xs = "_ee-2";
export var xxs = "_ee-1";